import React from 'react';
import { View, Alert, Text, ScrollView, StyleSheet, Image, Dimensions } from 'react-native';
import sha256 from 'crypto-js/sha256';

import Colors from '../../constants/Colors';
import { inputTextImageContainer } from '../../constants/Styles';

import {Input, Button, Spacing, DropdownElement, InformationDialogue} from '../../components';

import stateData from './data/estados-cidades.json';
import {stringIsEmpty} from "../../constants/StringChecker";

class RegisterScreen extends React.Component {
    static navigationOptions = {
        title: 'Registro',
    };

    state = {
        userEmail: '',
        userName: '',
        userNickname: '',
        userPassword: '',
        confirmPassword: '',
        estabelecimento: '',
        telefone: '',
        cidade: '',
        estado: '',
        cnpj: '',
        cpf: '',

        estadoDropdown: [],

        errorModalVisible: false,
        errorDescription: "",

        dimensions: null,
    };

    resetState = () => {
        this.setState({
            userEmail: "",
            userName: "",
            userNickname: "",
            userPassword: "",
            confirmPassword: "",
            estabelecimento: "",
            telefone: "",
            cidade: "",
            estado: "",
            cnpj: "",
            cpf: "",

            errorModalVisible: false,
            errorDescription: "",
        })
    }

    validateInput = () => {
        const { userEmail, userName, userNickname,  userPassword, confirmPassword, estabelecimento,
            telefone, estado, cidade, cnpj } = this.state;

        if (userPassword !== confirmPassword) {
            this.setState({ errorModalVisible: true, errorDescription: 'As senhas não estão iguais!' })
            return;
        }

        //Check if we have ok information before going to ToS
        if (stringIsEmpty(userEmail) || stringIsEmpty(userName) ||  stringIsEmpty(userNickname) || stringIsEmpty(userPassword) ||
            stringIsEmpty(estabelecimento) || stringIsEmpty(telefone) || stringIsEmpty(estado) || stringIsEmpty(cidade) ||
            stringIsEmpty(cnpj)) {

            this.setState({ errorModalVisible: true, errorDescription: 'É necessário fornecer todos os dados para registro!' })
            return;
        }

        const user = {
            email: userEmail,
            userName: userName,
            userNickname: userNickname,
            userPassword: sha256(userPassword).toString(),
            telefone: telefone,
            estado: estado,
            cidade: cidade,
            cnpj: cnpj,
            estabelecimento: estabelecimento,
        };

        this.props.history.push('/tos', { userToRegister: user });
    }

    handleResize = (dimensions) => {
        this.setState({ dimensions: dimensions });
    };

    componentWillUnmount() {
        Dimensions.removeEventListener("change", this.handleResize);
    }

    componentDidMount() {
        this.resetState();

        //Load data for picker!
        const data = stateData.estados.map(item => {
            return {
                value: item.sigla,
                label: item.nome,
            }
        })

        this.setState({
            estadoDropdown: data,
            dimensions: {
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            }
        })

        Dimensions.addEventListener("change", this.handleResize)
    }

    render() {

        const height =  this.state.dimensions === null ? '100%' : this.state.dimensions.window.height;
        const width =  this.state.dimensions === null ? '100%' : this.state.dimensions.window.width;

        return (
            <View style={{
                alignItems: 'center',
                minWidth: width,
                minHeight: height,
                backgroundColor: Colors.backgroundColor,
                padding: 22,
            }}>

                <InformationDialogue
                    isModalVisible={this.state.errorModalVisible}
                    titleText={"Erro"}
                    descriptionText={this.state.errorDescription}
                    onClose={() => this.setState({ errorModalVisible: false })}
                />

                <Image
                    source={require('../../img/logos/logoLogin.png')}
                    style={{ height: 128, width: 128 }}
                    resizeMode={'contain'}
                />

                <Spacing height={22} />

                <Input
                    label="E-mail:"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="email@email.com.br"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ userEmail: input })}
                    value={this.state.userEmail}
                    keyboardType={'email-address'}
                    autoCapitalize={'none'}
                    containerStyle={inputTextImageContainer}
                />

                <Input
                    label="Nome:"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="nome e sobrenome"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ userName: input })}
                    value={this.state.userName}
                    keyboardType={'default'}
                    autoCapitalize={'words'}
                    containerStyle={inputTextImageContainer}
                />

                <Input
                    label="Apelido:"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="apelido"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ userNickname: input })}
                    value={this.state.userNickname}
                    keyboardType={'default'}
                    autoCapitalize={'words'}
                    containerStyle={inputTextImageContainer}
                />

                <Input
                    label="Telefone:"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="(DD) 0000-0000"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ telefone: input })}
                    value={this.state.telefone}
                    keyboardType={'phone-pad'}
                    autoCapitalize={'words'}
                    containerStyle={inputTextImageContainer}
                />

                <DropdownElement
                    label={"Estado:"}
                    dropdownData={this.state.estadoDropdown}
                    currentSelection={this.state.estado}
                    onPickerSelection={(itemValue) => this.setState({ estado: itemValue })}
                    labelStyle={styles.inputLabelStyle}
                    containerStyle={inputTextImageContainer}

                />

                <Input
                    label="Cidade:"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="cidade"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ cidade: input })}
                    value={this.state.cidade}
                    keyboardType={'default'}
                    autoCapitalize={'words'}
                    containerStyle={inputTextImageContainer}
                />

                <Input
                    label="CNPJ:"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="CNPJ"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ cnpj: input })}
                    value={this.state.cnpj}
                    keyboardType={'numeric'}
                    autoCapitalize={'words'}
                    containerStyle={inputTextImageContainer}
                />

                <View style={{ flexDirection: 'row', alignItems: 'center', padding: 12, maxWidth: 300 }}>
                    <Image
                        source={require('../../img/icons/SobreIcon.png')}
                        style={{ height: 16, width: 16, tintColor: Colors.buttonColor, marginRight: 8 }}
                        resizeMode={'contain'}
                    />
                    <Text >
                        Atenção! Caso você não tenha um CNPJ, preencha o campo utilizando o seu CPF!
                    </Text>
                </View>

                <Input
                    label="Estabelecimento"
                    labelStyle={styles.inputLabelStyle}
                    placeholder="(Nome Fantasia)"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ estabelecimento: input })}
                    value={this.state.estabelecimento}
                    keyboardType={'default'}
                    autoCapitalize={'words'}
                    containerStyle={inputTextImageContainer}
                />

                <Input
                    label="Senha:"
                    labelStyle={styles.inputLabelStyle}
                    // secureTextEntry
                    placeholder="**********"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ userPassword: input })}
                    value={this.state.userPassword}
                    keyboardType={'default'}
                    autoCapitalize={'none'}
                    containerStyle={inputTextImageContainer}
                />

                <Input
                    label="Confirme senha:"
                    labelStyle={styles.inputLabelStyle}
                    // secureTextEntry
                    placeholder="**********"
                    placeholderTextColor={Colors.inputPlaceholderFontColor}
                    onChangeText={(input) => this.setState({ confirmPassword: input })}
                    value={this.state.confirmPassword}
                    keyboardType={'default'}
                    autoCapitalize={'none'}
                    containerStyle={inputTextImageContainer}
                />

                {/*<Text style={{ textAlign: 'center', marginTop: 10 }} >Os campos marcados com * são obrigatórios</Text>*/}


                <Button
                    text={'Próximo'}
                    containerPropsStyle={styles.buttonContainerStyle}
                    onPress={() => this.validateInput()}
                />

                <Button
                    text={'Voltar'}
                    containerPropsStyle={styles.buttonContainerStyle}
                    onPress={() => {
                        this.props.history.push('/');
                    }}
                />

            </View>
        )
    }
}

const styles = StyleSheet.create({
    mainLogo: {
        width: '80%',
        height: '35%',
    },
    inputTextStyle: {
        height: 10,
        width: 10,
    },
    inputLabelStyle: {
		marginRight: 10,
		color: Colors.inputFontColor,
		fontWeight: 'bold',
		fontSize: 16,
    },
    buttonContainerStyle: {
        marginRight: 30,
        marginLeft: 30,
        marginBottom: 10,
        marginTop: 10,
        borderRadius: 4,
        height: 40,
        width: 300,
        alignSelf: 'center',
    }
});

export default RegisterScreen;
